import createConstant from '../../utils/createConst'

export const GET_EVENT_LISTS = createConstant('event/GET_EVENT_LISTS')
export const GET_SUBEVENT_LISTS = createConstant('event/GET_SUBEVENT_LISTS')
export const GET_EVENT_CATEGORIES = createConstant('event/GET_EVENT_CATEGORIES')
export const GET_FILTER_EVENT = createConstant('event/GET_FILTER_EVENT')
export const GET_EVENT_PROMOTED = createConstant('event/GET_EVENT_PROMOTED')
export const GET_EVENT_DETAIL = createConstant('event/GET_EVENT_DETAIL')
export const GET_OTHER_EVENTS = createConstant('event/GET_OTHER_EVENTS')
export const LOAD_MORE_EVENTS = createConstant('event/LOAD_MORE_EVENTS')
export const LIKE_EVENT = createConstant('event/LIKE_EVENT')



// WEBPACK FOOTER //
// ./src/modules/Event/constants.js